var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.TableControlTypeConst[_vm.itemSchema.displayType.toLowerCase()],{tag:"component",class:{
    [_vm.$style.controlContainer] : true,
    [_vm.$style.fixedSize]: _vm.useFixedSize
  },attrs:{"control":_vm.itemSchema,"handleValueChange":_vm.handleValueChange,"onlyBreakAtNewlines":true,"resizeable":true,"smallInput":true,"value":_vm.findControlValue(_vm.itemSchema.name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }